<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="name">
        <span slot="label">
          <a-tooltip>账号<template slot="title">账号</template></a-tooltip>
        </span>
        <a-input v-model="form.name" :maxLength="255" :placeholder="$t('通用.输入.请输入')+'账号'"/>
      </a-form-model-item>
      <a-form-model-item prop="password">
        <span slot="label">
          <a-tooltip>密码<template slot="title">密码</template></a-tooltip>
        </span>
        <a-input v-model="form.password" :maxLength="255" :placeholder="$t('通用.输入.请输入')+'密码'"/>
      </a-form-model-item>
      <a-form-model-item label="头像" prop="avatar">
        <oss-upload-single :height="100" :width="100"  v-model="form.avatar" prefix="goods" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="status">
        <span slot="label">
          <a-tooltip>状态<template slot="title">状态 1 激活  0禁用</template></a-tooltip>
        </span>
        <a-select v-model="form.status" placeholder="请选择" >
          <a-select-option :value="1">激活</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="maxServiceNum">
        <span slot="label">
          <a-tooltip>最大服务人数<template slot="title">最大服务人数</template></a-tooltip>
        </span>
        <a-input v-model="form.maxServiceNum" :placeholder="$t('通用.输入.请输入')+'最大服务人数'"/>
      </a-form-model-item>
      <a-form-model-item prop="groupId">
        <span slot="label">
          <a-tooltip>分组<template slot="title">分组</template></a-tooltip>
        </span>
        <a-select v-model="form.groupId" :maxLength="32" :placeholder="$t('通用.输入.请选择')+'分组'" allow-clear>
          <a-select-option v-for="item in groupList" :key="item.groupId">{{ item.groupName }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getCustomerStaff, addCustomerStaff, updateCustomerStaff} from '@/api/customer/customerStaff'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import {selectCustomerGroup} from "@/api/customer/customerGroup";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";


export default {
  name: 'CreateForm',
  props: {},
  components: {
    OssUploadSingle,
    CustomDictTag,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      groupList:[],
      // 表单参数
      form: {
        id: null,
        name: null,
        password: null,
        maxServiceNum: null,
        groupId: null,
        avatar: null,
        sellerId: null,
        sellerCode: null,
        deptId: null,
        merchantId: null,
        createTime: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [{required: true, message: '账号' + this.$t('通用.文本.不能为空'), trigger: 'blur'}],
        password: [{required: true, message: '密码' + this.$t('通用.文本.不能为空'), trigger: 'blur'}],
        groupId: [{required: true, message: '分组' + this.$t('通用.文本.不能为空'), trigger: 'change'}],
        status: [{required: true, message: '状态' + this.$t('通用.文本.不能为空'), trigger: 'change'}],
        maxServiceNum: [{required: true, message: '服务人数' + this.$t('通用.文本.不能为空'), trigger: 'blur'}],
        avatar: [{required: true, message: '服务人数' + this.$t('通用.文本.不能为空'), trigger: 'change'}],
      }
    }
  },
  filters: {},
  created() {
    this.getGroup();
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        password: null,
        maxServiceNum: null,
        groupId: null,
        avatar: null,
        sellerId: null,
        sellerCode: null,
        deptId: null,
        merchantId: null,
        createTime: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCustomerStaff({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    getGroup() {
      selectCustomerGroup().then(response => {
        this.groupList = response.data
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateCustomerStaff(this.form).then(response => {
              this.$message.success(message, 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addCustomerStaff(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
